// Tiny module-level cache mapping a photo's src to its known aspect ratio
// (naturalWidth / naturalHeight). Each PhotoStage instance is keyed to a
// single photo for its whole lifetime, so a fresh mount otherwise has no
// way to know that photo's shape until its own image reports back — this
// is what shows up as the frame visibly popping from a placeholder ratio
// into its real one right after a skip or category jump, since those cut
// straight to a brand new PhotoStage with no earlier mount to inherit
// from (a swipe doesn't have this problem: the destination panel is
// already mounted, and already correctly shaped, before it ever becomes
// the visible slot).
//
// Any PhotoStage — current or not — that learns a ratio stores it here,
// and PhotoViewer's own preloading does too (see its preload effect), so
// by the time the user actually skips or jumps to a photo, its ratio is
// almost always already known and the next PhotoStage mounted for it
// starts out correctly shaped from the very first paint.
const cache = new Map();

export const getCachedRatio = src => cache.get(src);

export const setCachedRatio = (src, ratio) => {
  if (ratio && Number.isFinite(ratio)) cache.set(src, ratio);
};
